import Resource from '../../../../api/resource';

export class KategoriService extends Resource {
  constructor() {
    super('kategori', '/api', 'api-poi', 'v2');
  }
  getAll() {
    const params = {
      meta: {
        pageSize: 400,
        page: 1,
      },
    };
    const urlParams = JSON.stringify(params);
    this.setAdditionUri('/v3/all');
    return this.list({ params: urlParams });
  }
}
